// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"e6af15e3","453":"5bb567fa"}[chunkId] + ".chunk.js";
};